import { Link } from "react-router-dom";

const AboutLinks = () => {
  return (
    <div className="flex flex-col items-center lg:items-start justify-center gap-2 text-center 
    w-[10rem] lg:w-[7rem] text-yellow-600 lg:text-right whitespace-nowrap">
      <p className="text-yellow-900 font-bold text-xl">جرين تكنولوجي</p>
      <Link to="/aboutus">
        <p className="hover:underline">عن جرين تكنولوجي</p>
      </Link>
      <Link to="/privacypolicy" className="hover:underline">
        <p className="hover:underline">سياسة</p>
        <p>الخصوصيه</p>
      </Link>
    </div>
  );
};

export default AboutLinks;
